export default "__VITE_ASSET__cYwkTHBn__"